document.addEventListener('DOMContentLoaded', function() {
  var dobPopup = document.getElementById('dob-popup');
  if (dobPopup) {
    dobPopup.style.display = 'block';
  }
  
  var dobForm = document.getElementById('dob-form');
  if (dobForm) {
    dobForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var dob = document.getElementById('dob-input').value;
      if (dob) {
        // Change the URL below to your custom endpoint (or app proxy) that updates the customer's metafield.
        fetch('/apps/update-customer-dob', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ dob: dob })
        })
        .then(function(response) {
          if (response.ok) {
            dobPopup.style.display = 'none';
            alert('Thank you! Your birthday information has been updated.');
          } else {
            alert('There was an error updating your information. Please try again.');
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
          alert('There was an error updating your information.');
        });
      }
    });
  }
});
